import React from 'react';
import clsx from 'clsx';
import { DatePicker } from '@material-ui/pickers';
import { createStyles } from '@material-ui/styles';
import { IconButton, withStyles } from '@material-ui/core';
import styled from 'styled-components';
import moment, { isDate } from 'moment';

const makeJSDateObject = (date) => new Date(date);

function WeekPicker(props) {
  const {
    value,
    onChange,
    selector,
    label,
    inputSize = 40,
    inputBaseMinWidth = 260,
  } = props;

  const StyledDatePicker = styled(DatePicker)`
    .MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom: 1px solid grey;
    }
    .MuiInput-underline:before {
      transition: none;
      border-bottom: none;
      pointer-events: none;
    }
    .MuiFormControl-root {
      width: 100%;
    }
    .MuiInputBase-input {
      min-width: ${inputBaseMinWidth};
      text-align: center;
      font-size: 14px;
      color: #7a869a;
    }
    .MuiInput-underline:after {
      transform: none;
      transition: none;
      border-bottom: none;
    }
  `;

  const formatWeekSelectLabel = (date, invalidLabel) => {
    let dateClone = makeJSDateObject(date);
    // console.log('dateClone', dateClone);
    return dateClone && isDate(dateClone)
      ? `${moment(date)
          .startOf('week')
          .format('MMMM-DD-YYYY')
          ?.toLocaleUpperCase()} TO ${moment(date)
          .endOf('week')
          .format('MMMM-DD-YYYY')
          ?.toLocaleUpperCase()}`
      : //   ? `${format(
        //       startOfWeek(dateClone),
        //       'MMMM-dd-yyyy'
        //     )?.toLocaleUpperCase()} TO ${format(
        //       endOfWeek(dateClone),
        //       'MMMM-dd-yyyy'
        //     )?.toLocaleUpperCase()}`
        invalidLabel;
  };

  const formatDaySelectLabel = (date, invalidLabel) => {
    let dateClone = makeJSDateObject(date);
    return dateClone && isDate(dateClone)
      ? `${moment(date).format('MMMM-DD-YYYY').toLocaleUpperCase()}`
      : invalidLabel;
  };

  const renderWrappedWeekDay = (date, selectedDate, dayInCurrentMonth) => {
    const { classes } = props;
    let dateClone = makeJSDateObject(date);
    let selectedDateClone = makeJSDateObject(selectedDate);

    const start = moment(selectedDateClone).startOf('week').toDate();
    const end = moment(selectedDateClone).endOf('week').add(1, 'day').toDate();

    const dayIsBetween = moment(dateClone).isBetween(start, end);
    const isFirstDay = moment(dateClone).isSame(start);
    const isLastDay = moment(dateClone).isSame(end);

    const wrapperClassName = clsx({
      [classes.highlight]: dayIsBetween,
      [classes.firstHighlight]: isFirstDay,
      [classes.endHighlight]: isLastDay,
    });

    const dayClassName = clsx(classes.day, {
      [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
      [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
    });

    return (
      <div className={wrapperClassName}>
        <IconButton className={dayClassName}>
          <span> {moment(dateClone).format('DD')} </span>
        </IconButton>
      </div>
    );
  };
  const inputProps = {
    size: inputSize,
  };

  return (
    <>
      {selector === 'week' ? (
        <StyledDatePicker
          value={value}
          onChange={onChange}
          renderDay={renderWrappedWeekDay}
          labelFunc={formatWeekSelectLabel}
          inputProps={inputProps}
          {...props}
        />
      ) : (
        <>
          {selector === 'day' ? (
            <StyledDatePicker
              value={value}
              onChange={onChange}
              labelFunc={formatDaySelectLabel}
              inputProps={inputProps}
              {...props}
            />
          ) : (
            <StyledDatePicker
              value={value}
              onChange={onChange}
              labelFunc={label}
              inputProps={inputProps}
              {...props}
            />
          )}
        </>
      )}
    </>
  );
}

const styles = createStyles((theme) => ({
  dayWrapper: {
    position: 'relative',
  },
  day: {
    width: 36,
    height: 36,
    fontSize: theme.typography.caption.fontSize,
    margin: '0 2px',
    color: 'inherit',
  },
  customDayHighlight: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '2px',
    right: '2px',
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: '50%',
  },
  nonCurrentMonthDay: {
    color: theme.palette.text.disabled,
  },
  highlightNonCurrentMonthDay: {
    color: '#676767',
  },
  highlight: {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  firstHighlight: {
    extend: 'highlight',
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%',
  },
  endHighlight: {
    extend: 'highlight',
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
  },
}));

// export default withStyles(styles)(CustomElements);
export default withStyles(styles)(WeekPicker);
